
import React from 'react'
import _ from 'lodash'

import { Button } from 'browser/components/atomic-elements/atoms/button/button'
import apis from 'browser/app/models/apis'
import { IEmail, IPhone } from './types'
import { isVerified } from './utils'

import { Popover } from 'browser/components/atomic-elements/atoms/popover/popover'
import { TetherTarget } from 'browser/components/atomic-elements/atoms/tether-target'

/**
 * @uiComponent
 */
interface IImpersonateButtonProps {
  targetUserId: string
  phoneNumbers?: IPhone[]
  additionalIdentities: any[]
  emails?: IEmail[]
}

export const ImpersonateButton: React.FC<IImpersonateButtonProps> = (props) => {
  const { emails, phoneNumbers, additionalIdentities, targetUserId } = props

  const impersonate = (identity: string) => {
    apis.impersonate(targetUserId, identity).then(() => {
      // The token doesn't change - just the database record is updated
      // Reload to fetch the new user/firm context
      window.location.href = '/'
    })
  }

  const verifiedEmails: string[] = _.map(_.filter(emails, isVerified), 'value')
  const verifiedPhones: string[] = _.map(_.filter(phoneNumbers, isVerified), 'value.phone')
  const driverUniqueIds: string[] = _.map(additionalIdentities, 'driverUniqueId')
  const allLogins = _.concat(verifiedEmails, verifiedPhones, driverUniqueIds)

  if (!apis.getSettings().isAdmin) {
    return null
  }

  if (allLogins.length <= 1) {
    return <Button isDisabled={allLogins.length === 0} buttonText="Impersonate" onClick={() => impersonate(allLogins[0])} />
  } else {
    return (
      <TetherTarget
        closeOnPortalClick={true}
        tethered={(
          <Popover className="collapse" data-debug-id="document-options-dropdown">
            <div>
              <ul className="c-dropdownList">
                {allLogins.map((identity) => (
                  <li className="c-dropdownList-item" onClick={() => impersonate(identity)} key={identity}>
                    {identity}
                  </li>
                ))}
              </ul>
            </div>
          </Popover>
        )}
      >
        <Button buttonText="Impersonate" />
      </TetherTarget>
    )
  }
}
